module.exports = __webpack_public_path__ + "static/media/coin.87135dce.svg";